import { Navigate } from "react-router-dom";
import VoyageInformation from "./VoyageInformation/VoyageInformation";
import VesselReportingInfo from "./VesselReportingInfo/VesselReportingInfo";
import DeckOfficerWizard from "./ReportingWizard/DeckOfficerReport/DeckOfficerReporting";
import EngineerWizard from "./ReportingWizard/EngineerReport/EngineerReporting";
import VesselMachinerySettings from "./VesselMaster/VesselConfiguration/VesselConfiguration";
import VesselAdditionalInformation from "./VesselMaster/AdditionalInformation/AdditionalInformation";
import VesselPerformance from 'VesselPerformance/VesselPerformance';
import ProfileDetail from "./Header/TopbarDropdown/ProfileDetails";
import SingleReportView from "./ReportingWizard/SingleReportView";
import { Roles } from "./shared/constants";
import React, { Suspense, lazy } from "react";
import DashboardFleet from "Dashboard/DashboardFleet";
import Loading from "Components/Loading";
import STSAdjustment from "Adjustments/STSAdjustment/STSAdjustment";
import FCeboAdjustment from "Adjustments/FC(e+b+o)Adjustment/FCeboAdjustment";
import VoyageAdjustment from "Adjustments/VoyageAdjustment/VoyageAdjustment";

interface RouteProps {
  path: string;
  component?: any;
  exact?: boolean;
  allowedRole?: string[]
}

const CIIAssessment = lazy(() => import('CIIAssessment/CIIAssessment'));
const CIISimulator = lazy(() => import('CIISimulator.tsx/CIISimulator'));
const EuMrvEts = lazy(() => import('./EuMrvEts/EuMrvEts'));
const VoyageEstimator = lazy(() => import('CIISimulator.tsx/VoyageEstimator/VoyageEstimator'));
const Fleets = lazy(() => import('Fleets/Fleets'));
const GenericIndex = lazy(() => import('./GenericForms/Generic.index'));
const ImoDcs = lazy(() => import('ImoDcs.tsx/ImoDcs'));
const ReportGeneration = lazy(() => import('ReportGeneration/ReportGeneration'));
const UkMrv = lazy(() => import('UkMrv/UkMrv'));
const VesselMaster = lazy(() => import('./VesselMaster/VesselMaster'));
const Dashboard = lazy(() => import('./Dashboard/Dashboard'));
const userRoutes: Array<RouteProps> = [
  //Generic Master
  {
    path: "/masters/:masters",
    component:
      <Suspense
        fallback={<div className="lazy-load-component"><Loading message="Please wait..." /></div>}>
        <GenericIndex />
      </Suspense>,
    allowedRole: [Roles.ES_ADMIN]
  },
  {
    path: "/reporting/voyage_reporting",
    component: <VoyageInformation />,
    allowedRole: [Roles.MASTER, Roles.ES_ADMIN]
  },
  {
    path: "/reporting/vessel_reporting",
    exact: true,
    component: <VesselReportingInfo />,
    allowedRole: [Roles.MASTER, Roles.CHIEFENGINEER, Roles.ES_ADMIN]
  },
  {
    path: "/reporting/deck_officer_reporting",
    exact: true,
    component: <DeckOfficerWizard />, allowedRole: [Roles.MASTER, Roles.ES_ADMIN]
  },
  {
    path: "/reporting/engineer_reporting",
    exact: true,
    component: <EngineerWizard />,
    allowedRole: [Roles.CHIEFENGINEER, Roles.ES_ADMIN]
  },
  {
    path: "/masters/vessel_master",
    component:
      <Suspense
        fallback={<div className="lazy-load-component"><Loading message="Please wait..." /></div>}>
        <VesselMaster />
      </Suspense>,
    allowedRole: [Roles.ES_ADMIN]
  },
  {
    path: '/dashboard',
    component:
      <Suspense
        fallback={<div className="lazy-load-component"><Loading message="Please wait..." /></div>}>
        <Dashboard />
      </Suspense>,
    allowedRole: [Roles.MANAGER, Roles.MASTER, Roles.CHIEFENGINEER, Roles.ES_ADMIN]
  },
  {
    path: "/dashboard_fleet",
    component: <DashboardFleet />,
    allowedRole: [Roles.MANAGER, Roles.ES_ADMIN]
  },
  {
    path: "/fleet_management",
    component:
      <Suspense
        fallback={<div className="lazy-load-component"><Loading message="Please wait..." /></div>}>
        <Fleets />
      </Suspense>,
    allowedRole: [Roles.MANAGER, Roles.ES_ADMIN]
  },
  {
    path: "/cii_assessment/",
    component:
      <Suspense
        fallback={<div className="lazy-load-component"><Loading message="Please wait..." /></div>}>
        <CIIAssessment />
      </Suspense>,
    allowedRole: [Roles.MANAGER, Roles.ES_ADMIN]
  },
  {
    path: "/imo_dcs/",
    component: <Suspense
      fallback={<div className="lazy-load-component"><Loading message="Please wait..." /></div>}>
      <ImoDcs />
    </Suspense>,
    allowedRole: [Roles.MANAGER, Roles.ES_ADMIN]
  },
  {
    path: "/eu_mrv_ets/",
    component:
      <Suspense
        fallback={<div className="lazy-load-component"><Loading message="Please wait..." /></div>}>
        <EuMrvEts />
      </Suspense>,
    allowedRole: [Roles.MANAGER, Roles.ES_ADMIN]
  },
  {
    path: "/uk_mrv/",
    component:
      <Suspense
        fallback={<div className="lazy-load-component"><Loading message="Please wait..." /></div>}>
        <UkMrv />
      </Suspense>,
    allowedRole: [Roles.MANAGER, Roles.ES_ADMIN]
  },
  {
    path: "/vessel_performance",
    component: <VesselPerformance />,
    allowedRole: [Roles.MANAGER, Roles.ES_ADMIN]
  },
  {
    path: "/vessel_configuration",
    component: <VesselMachinerySettings />,
    allowedRole: [Roles.ES_ADMIN]
  },
  {
    path: "/vessel_additional_information",
    component: <VesselAdditionalInformation />,
    allowedRole: [Roles.ES_ADMIN]
  },
  {
    path: "/contacts-profile",
    component: <ProfileDetail />
  },
  {
    path: '/testing',
    component: <SingleReportView />
  },
  {
    path: '/cii_simulator',
    component:
      <Suspense
        fallback={<div className="lazy-load-component"><Loading message="Please wait..." /></div>}>
        <CIISimulator />
      </Suspense>
  },
  {
    path: '/voyage_estimator',
    component:
      <Suspense
        fallback={<div className="lazy-load-component"><Loading message="Please wait..." /></div>}>
        <VoyageEstimator />
      </Suspense>
  },
  {
    path: '/report_generation',
    component:
      <Suspense
        fallback={<div className="lazy-load-component"><Loading message="Please wait..." /></div>}>
        <ReportGeneration />
      </Suspense>
  },
  {
    path: '/voyage_adjustment',
    component:
      <Suspense
        fallback={<div className="lazy-load-component"><Loading message="Please wait..." /></div>}>
        <VoyageAdjustment />
      </Suspense>
  },
  {
    path: '/sts_adjustment',
    component:
      <Suspense
        fallback={<div className="lazy-load-component"><Loading message="Please wait..." /></div>}>
        <STSAdjustment />
      </Suspense>
  },
  {
    path: '/FC(elec+boiler+other)_adjustment',
    component:
      <Suspense
        fallback={<div className="lazy-load-component"><Loading message="Please wait..." /></div>}>
        <FCeboAdjustment />
      </Suspense>
  },
  { path: "/", exact: true, component: <Navigate to="/login" /> },
];

/**
 * Filter out roles which are applicable to the role based on session
 */
const userAllowedRoutes = userRoutes;
// .filter((route: any) => {
//   const roles = getAuthData('roles');
//   if (!roles) {
//     return [];
//   }
// Check if at least one allowed role is present in the roles array

//   return (route.hasOwnProperty('allowedRole')) ?
//     (route?.allowedRole?.some((allowedRole: any) =>
//       roles && roles?.some((role: any) => role.role_name === allowedRole)
//     )) : route;
// });

export { userRoutes, userAllowedRoutes };